import { useFreecodeContextData, useFreecodeContextLayout } from 'hooks/useContext';
import { editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { sendPrimusRequest } from 'api/PrimusWebSocket';
import { useCallback } from 'react';

export default function useFreecodeLivePrimus() {
  const { ticket } = useFreecodeContextData();
  const { editorType } = useFreecodeContextLayout();

  const sendTicketPrimusRoomRequest = useCallback(
    (data) => {
      if (!ticket?._id) return;
      if (![editorTypes.freecode, editorTypes.liveCoding].includes(editorType)) return;
      sendPrimusRequest({
        ...data,
        ticketId: ticket._id,
        _handler: 'ticket-primus-room-connection',
      });
    },
    [ticket, editorType]
  );

  return sendTicketPrimusRoomRequest;
}
